module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/petition/petition-form/petition-form.component.css
// module id = ./src/app/petition/petition-form/petition-form.component.css
// module chunks = main